import { FolderOpen } from '@mui/icons-material';
import { Box, Button, styled, TextField, Typography } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

export const InputTextField = styled(TextField)`
  width: 100%;
`;

export const InputDate = styled(MobileDatePicker)(
  ({ theme }) => `
  width: 100%;
  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color:${theme.palette.brand.disabled};
  }
  .Mui-disabled .MuiSvgIcon-root {
    color:${theme.palette.brand.disabled};
  }
`,
);

export const Wrapper = styled(Box)`
  height: 100vh;
  overflow: auto;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const Step = styled(Box)`
  width: 100%;
  min-height: 100%;
  margin: auto;
  padding: 0 70px;
`;

export const LayoutTypeWrapper = styled(Box)`
  display: flex;
  gap: 30px;
  margin: 30px 0;
  padding: 3px;
  overflow-y: auto;
  overflow-x: hidden;

  button {
    padding: 20px;
    font-size: 1rem;
  }
`;

export const IconContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  padding: 20px;
`;

export const OutdoorIconContainer = styled(IconContainer)`
  padding: 0;
`;

export const MacCafeIconContainer = styled(IconContainer)`
  padding: 20px;
`;

export const OptionWrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 1fr;
  gap: 40px;

  button {
    padding: 30px;
    font-size: 1rem;
  }
`;

export const FormWrapper = styled(Box)`
  text-align: left;
`;

export const ImageButton = styled(Button)(
  ({ theme, selected }) => `
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    gap: 45px;
    width: 100%;
    outline: 3px solid ${theme.palette.secondary.dark};
    background-color: ${theme.palette.secondary.contrastText};
    border-radius: 3px;
    color: ${theme.palette.secondary.dark};
    transition: all 0.1s ease-in-out;
    line-height:1;
    &:hover {
        outline: 3px solid ${theme.palette.primary.main};
        background-color: ${theme.palette.secondary.contrastText};
    }

    ${
      selected &&
      `
        outline: 3px solid ${theme.palette.primary.main};
        background-color: ${theme.palette.secondary.contrastText};
    `
    }
`,
);

export const StepContent = styled(Box)`
  margin: 30px 0;
`;

export const StepNavigation = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const StepNavigationButtonWrapperRight = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`;

export const OwnerOperatorContainer = styled(Box)`
  margin-top: 50px;
  width: 456px;
  margin: auto;
`;

export const MainOOContainer = styled(Box)`
  margin-top: 100px;
`;

export const CheckBoxContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OOText = styled(Typography)`
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
  font-family: Roboto;
`;

export const OOSubText = styled(Typography)(
  ({ theme }) => `
  margin-top: 15px;
  font-size: 16px;
  line-height: 18px;
  color: ${theme.palette.brand.charcoal}
`,
);

export const Container = styled(Box)`
  margin-top: 50px;
`;

export const FilterDropDownWithBadgesContainer = styled(Box)`
  margin-bottom: 15px;
`;

export const FolderOpenIconStyled = styled(FolderOpen)`
  font-size: 212px;
`;

export const SoftSellContainer = styled(Box)`
  margin-top: 50px;
`;
export const InputLabel = styled(Typography)(
  ({ theme, $disabled }) => `
  color: ${$disabled ? theme.palette.brand.disabled : 'inherit'}; 
  text-align: left;
  font-weight: 400;
`,
);
